/*eslint-disable*/
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import userApi from "../../../apis/users";
import loginApi from "../../../apis/login";
import { User } from "../../../types/userType";
import userUtils from "../../../utils/userUtils";
import authenticationUtils from "../../../utils/authenticationUtils";
import routes from "../../../constants/routes";
import { logoutAdmin } from "../AuthorizationSlice";
import { RequestStatus } from "../../../enums";

interface ProfileState {
  user?: User;
  isLoading: boolean;
  childAuthorized: boolean;
  redirectTo?: string;
  profileStatus?: RequestStatus;
}

const initialState: ProfileState = {
  user: undefined,
  isLoading: false,
  childAuthorized: false,
};

const fetchProfile = createAsyncThunk(
  "profile/get",
  async (_: void, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await userApi.me();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const authorizeChild = createAsyncThunk(
  "profile/authorizeChild",
  async (childUserId: string, { rejectWithValue, dispatch }) => {
    try {
      const { token }: any = await loginApi.doChildLogin(childUserId);
      authenticationUtils.saveToken(token);
      const { data } = await userApi.me();
      return {
        token,
        user: data,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearProfileState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        return {
          ...state,
          redirectTo: undefined,
          profileStatus: RequestStatus.LOADING,
        };
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        const user = action.payload;
        userUtils.saveUser(user);
        return {
          ...state,
          isLoading: false,
          user: action.payload,
          profileStatus: RequestStatus.SUCCESS,
        };
      })
      .addCase(fetchProfile.rejected, (state) => ({
        ...state,
        authorized: false,
        profileStatus: RequestStatus.FAILED,
      }))
      .addCase(logoutAdmin.fulfilled, () => initialState);
  },
});

export const { clearProfileState } = profileSlice.actions;
export { fetchProfile, authorizeChild };

export default profileSlice;
